export function createStatusStore(initial = { kind: 'loading' }) {
    let status = initial;
    const listeners = new Set();
    return {
        getStatus: () => status,
        subscribe(listener) {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        setStatus(next) {
            if (next === status)
                return;
            status = next;
            listeners.forEach((l) => l());
        },
    };
}
